import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { InactivityService } from '../../service/inactivity-service/inactivity.service';
import { AuthService } from '../../service/auth-service/auth-service.service';

@Component({
  selector: 'app-session-expired-info',
  templateUrl: './session-expired-info.component.html',
  styleUrl: './session-expired-info.component.scss'
})
export class SessionExpiredInfoComponent {
  isSessionExpired: boolean = false;
  
  constructor(
    private inactivityService: InactivityService, 
    private router: Router,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    // Don't allow to access this page if the session is still valid
    this.isSessionExpired = this.inactivityService.isSessionExpired();
    if (!this.isSessionExpired) {
      this.router.navigate(['/']);
    }
  }

  logout(): void {
    this.authService.logOut();
  }
}
